var _Rect, _Path, _Path2, _Path3, _Path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
var SvgGb = function SvgGb(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 28,
    height: 20,
    fill: "#fff",
    rx: 2
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#0A17A7",
    d: "M0 0h28v20H0z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m-1.282-1.916 11.949 8.06v-7.477h6.667v7.476l11.949-8.06 1.49 2.211-9.446 6.373H28v6.666h-6.674l9.448 6.373-1.491 2.21-11.95-8.06v7.477h-6.666v-7.476l-11.95 8.06-1.49-2.211 9.447-6.373H0V6.667h6.674L-2.773.294z",
    clipRule: "evenodd"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#DB1F35",
    strokeLinecap: "round",
    strokeWidth: 0.667,
    d: "M18.668 6.332 31.333-2m-11.32 15.698 11.353 7.652M8.006 6.31-3.837-1.67M9.29 13.605l-13.127 8.706"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fill: "#E6273E",
    fillRule: "evenodd",
    d: "M0 12h12v8h4v-8h12V8H16V0h-4v8H0z",
    clipRule: "evenodd"
  })));
};
export default SvgGb;